import { CSSObject } from '@chakra-ui/react';
import { TBodyTextProps } from '../types';

export const BodyText = ({ heading }: TBodyTextProps): CSSObject => ({
  '&&': {
    fontSize: heading ? 'sm' : 'xs',
    fontWeight: heading ? 'semibold' : 'normal',
    fontFamily: 'body',
    color: 'gamma.200',
    lineHeight: '1.3',
  },
});

export const RadioText: CSSObject = {
  '&&': {
    fontSize: 'xs',
    mb: '2',
    fontWeight: 'medium',
    color: 'gamma.200',
  },
};

export const DepositLimitContainer: CSSObject = {
  mt: '4',
  border: '1px dashed',
  borderColor: 'whiteAlpha.500',
  borderRadius: 'base',
  maxW: ['100vw', null, '500px'],
  p: '4',
  '.chakra-input__group': {
    bg: 'alpha.700',
    display: 'flex',
    alignItems: 'center',
    borderRadius: 'md',
    boxShadow:
      '0px 1px 5px 0px rgba(0, 0, 0, 0.15) inset, 0px 1px 0px 0px rgba(255, 255, 255, 0.1)',
  },
  '.chakra-input__left-addon': {
    bg: 'gamma.600',
    fontSize: 'xs',
    fontWeight: 'semibold',
    borderRadius: 'base',
    h: '4',
    color: 'alpha.700',
    px: '1',
    mx: '2',
  },
  '.chakra-select': {
    bg: 'alpha.700',
    fontSize: 'xs',
    color: 'gamma.200',
    border: 'none',
    option: {
      color: 'black',
    },
  },
  '.chakra-select__icon-wrapper': {
    color: 'gamma.600',
  },
  '#limitAmount-input': {
    fontSize: 'xs',
    fontWeight: 'medium',
    bg: 'alpha.700',
    color: 'white',
    border: 'none',
    h: '9',
    px: '0',
    paddingLeft: '10px',
    ':hover, :focus': {
      bg: 'alpha.800',
      border: 'none',
    },
  },
  '.chakra-form__error-message': {
      bg: 'red.600',
      color: 'white',
      boxShadow:
        '0px 2px 4px 0px rgba(0, 0, 0, 0.20), 0px 1px 0px 0px rgba(255, 255, 255, 0.20) inset',
      borderRadius: 'base',
      p: '1',
      fontWeight: 'medium',
      fontSize: 'xs',
    },
};

export const FlexHeaderWrapper: CSSObject = {
  color: 'gray.500',
  fontSize: 'md',
  fontStyle: 'normal',
  fontWeight: 'semibold',
  mb: ['4', null, '5'],
  pt: [null, null, '1'],
  gap: '2',
};

export const ButtonSubmit: CSSObject = {
  textTransform: 'uppercase',
};

export const RadioLimitChoice: CSSObject = {
  bg: 'white',
  border: 'none',
  mb: '2',
  '&[data-checked]': {
    bg: 'alpha.500',
    borderWidth: '4px',
    borderStyle: 'solid',
    borderColor: 'white',
    color: 'alpha.500',
  },
  '&[data-checked]:hover': {
    bg: 'alpha.500',
    borderWidth: '4px',
    borderStyle: 'solid',
    borderColor: 'white',
    color: 'alpha.500',
  },
};
